import { MotionContainer, varBounce, Button } from '@mfw/components';
import Typography from '@mui/material/Typography';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { m } from 'framer-motion';

import { PageNotFoundIllustration } from '../assets/images/illustrations';
import RouterLink from '../components/RouterLink';
import messages from './messages';

// ----------------------------------------------------------------------

function NotFoundView() {
  const { formatMessage } = useIntl();
  return (
    <div className="w-full h-full flex items-center justify-center">
      <MotionContainer>
        <div className="w-full flex items-center justify-center">
          <m.div variants={varBounce().in}>
            <Typography variant="h3">
              {formatMessage(messages.pageNotFoundTitle)}
            </Typography>
          </m.div>
        </div>

        <div className="my-8">
          <m.div variants={varBounce().in}>
            <PageNotFoundIllustration />
          </m.div>
        </div>
        <div className="w-full flex items-center justify-center">
          <Button
            LinkComponent={RouterLink}
            variant="contained"
            size="large"
            href="/"
          >
            {formatMessage(messages.backToHome)}
          </Button>
        </div>
      </MotionContainer>
    </div>
  );
}

function NotFoundPage() {
  const { formatMessage } = useIntl();
  return (
    <>
      <Helmet>
        <title>{formatMessage(messages.pageNotFoundTitle)}</title>
      </Helmet>

      <NotFoundView />
    </>
  );
}

export default function NotFoundPageWrapper() {
  return <NotFoundPage />;
}
